<template>

    <b-modal
        id="move-modal"
        :title="title"
        ok-title="Zapisz"
        cancel-title="Anuluj"
        ok-variant="success"
        no-close-on-backdrop
        @ok="moveModalHandleOk"
        @hidden="moveModalHandleHide">
        <form @submit.prevent="submitMoveForm" @keydown="form.errors.clear($event.target.name)" ref="move-form">

            <div class="form-group">
                <label for="location_id">Położenie</label>
                <select class="form-control" id="location_id" v-model="form.location_id">
                    <option :value="null" disabled selected>Wybierz</option>
                    <option v-for="location in locations" :value="location.id">{{ location.text }}</option>
                </select>
                <span class="error mt-2 text-danger" v-if="form.errors.has('location_id')" v-text="form.errors.get('location_id')"></span>
            </div>

        </form>
    </b-modal>

</template>

<script>
    export default {

        name: 'GameLibraryMoveModal',

        props: [
            'repo',
            'allLocations'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                type: null,
                element: null,
                title: null,
                locations: [],
                form: new Vue.prototype.Form({
                    type: null,
                    element_id: null,
                    location_id: null
                })
            }
        },

        mounted() {

            // Set variables and show modal
            this.eventHub.$on('game-library-move-element', (type, element) => {
                this.type = type;
                this.element = element;
                let locationId;
                switch (this.type) {
                    case 'package':
                        this.title = 'Przenieś pakiet';
                        this.locations = this.allLocations.areas;
                        locationId = element.area_id;
                        break;
                    case 'set':
                        this.title = 'Przenieś zestaw';
                        this.locations = this.allLocations.packages;
                        locationId = element.package_id;
                        break;
                    case 'game':
                        this.title = 'Przenieś grę';
                        this.locations = this.allLocations.sets;
                        locationId = element.set_id;
                        break;
                }
                this.form = new Vue.prototype.Form({
                    type: this.type,
                    element_id: this.element.id,
                    location_id: locationId
                });
                this.$bvModal.show('move-modal');
            });

        },

        methods: {

            moveModalHandleOk(event) {
                event.preventDefault();
                this.submitMoveForm();
            },

            moveModalHandleHide() {
                this.type = null;
                this.element = null;
                this.title = null;
                this.locations = null;
                this.form = new Vue.prototype.Form({
                    type: null,
                    element_id: null,
                    location_id: null
                });
            },

            submitMoveForm() {
                this.eventHub.$emit('processing-start');
                this.form.put(route('game::game-library.update-element-location', {repo: this.repo}))
                    .then(response => {
                        this.eventHub.$emit('game-library-updated', response.data.library);
                        this.$bvModal.hide('move-modal');
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        if (error.message) {
                            this.eventHub.$emit('toast-notification', error.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                        }
                    });
            }

        }

    }
</script>

<style scoped>

</style>
